// @generated by protoc-gen-es v2.11.0 with parameter "target=ts"
// @generated from file api_proto/v1/staff_permission.proto (package api_proto.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { CompanyFeatureAccess, LineReadiness } from "./staff_pb";
import { file_api_proto_v1_staff } from "./staff_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file api_proto/v1/staff_permission.proto.
 */
export const file_api_proto_v1_staff_permission: GenFile = /*@__PURE__*/
  fileDesc("CiNhcGlfcHJvdG8vdjEvc3RhZmZfcGVybWlzc2lvbi5wcm90bxIMYXBpX3Byb3RvLnYxIksKElBlcm1pc3Npb25Db2RlSXRlbRIMCgRjb2RlGAEgASgJEg0KBWxhYmVsGAIgASgJEhgKEGNvbnN1bWVzX2NyZWRpdHMYAyABKAgiHAoaTGlzdFBlcm1pc3Npb25Db2Rlc1JlcXVlc3QiWQobTGlzdFBlcm1pc3Npb25Db2Rlc1Jlc3BvbnNlEjoKEHBlcm1pc3Npb25fY29kZXMYASADKAsyIC5hcGlfcHJvdG8udjEuUGVybWlzc2lvbkNvZGVJdGVtIvMBChBTdGFmZlBlcm1pc3Npb25zEhgKEGNvbXBhbnlfc3RhZmZfaWQYASABKAMSDAoEbmFtZRgCIAEoCRIQCghhcmNoaXZlZBgDIAEoCBIYChBwZXJtaXNzaW9uX2NvZGVzGAQgAygJEhIKCnBsYW5fdHlwZXMYBSADKAkSEwoLYXJjaGl2ZWRfYXQYBiABKAkSEgoKaXNfc3VwcG9ydBgHIAEoCBIzCg5saW5lX3JlYWRpbmVzcxgIIAEoCzIbLmFwaV9wcm90by52MS5MaW5lUmVhZGluZXNzEhkKEWxpbmVfbGFzdF91c2VkX2F0GAkgASgJIlIKIkxpc3RDb21wYW55U3RhZmZQZXJtaXNzaW9uc1JlcXVlc3QSEgoKY29tcGFueV9pZBgBIAEoAxIYChBpbmNsdWRlX2FyY2hpdmVkGAIgASgIIm0KDVN0YWZmQ2FwYWNpdHkSHQoVYXNzaWduZWRfYWN0aXZlX2NvdW50GAEgASgDEg0KBWxpbWl0GAIgASgDEhQKDGhhc19vdmVycmlkZRgDIAEoCBIYChBoYXNfY3JtX2NvbnRyYWN0GAQgASgIIsgBCiNMaXN0Q29tcGFueVN0YWZmUGVybWlzc2lvbnNSZXNwb25zZRIuCgZzdGFmZnMYASADKAsyHi5hcGlfcHJvdG8udjEuU3RhZmZQZXJtaXNzaW9ucxI8ChBjb21wYW55X2ZlYXR1cmVzGAIgAygLMiIuYXBpX3Byb3RvLnYxLkNvbXBhbnlGZWF0dXJlQWNjZXNzEjMKDnN0YWZmX2NhcGFjaXR5GAMgASgLMhsuYXBpX3Byb3RvLnYxLlN0YWZmQ2FwYWNpdHkiggEKJFVwZGF0ZUNvbXBhbnlTdGFmZlBlcm1pc3Npb25zUmVxdWVzdBISCgpjb21wYW55X2lkGAEgASgDEhgKEGNvbXBhbnlfc3RhZmZfaWQYAiABKAMSGAoQcGVybWlzc2lvbl9jb2RlcxgDIAMoCRISCgpwbGFuX3R5cGVzGAQgAygJQjNaMWdpdGh1Yi5jb20vaC1zY2FwZS9pZXNhcHVyaS9nby9hcGlfcHJvdG8vdjE7YXBpdjFiBnByb3RvMw", [file_api_proto_v1_staff]);

/**
 * 権限コードカタログ 1 件。表示順はレスポンスの並び順に従う
 *
 * @generated from message api_proto.v1.PermissionCodeItem
 */
export type PermissionCodeItem = Message<"api_proto.v1.PermissionCodeItem"> & {
  /**
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * @generated from field: string label = 2;
   */
  label: string;

  /**
   * クレジットを消費する機能か（go/logic/credit の消費レート表に載っているか）。
   * 機能専用クレジットの付与対象を消費機能だけに絞る画面（Admin のクレジット手動付与）で使う。
   * スタッフ権限の付与では使わない（権限は全機能が対象）。
   *
   * @generated from field: bool consumes_credits = 3;
   */
  consumesCredits: boolean;
};

/**
 * Describes the message api_proto.v1.PermissionCodeItem.
 * Use `create(PermissionCodeItemSchema)` to create a new message.
 */
export const PermissionCodeItemSchema: GenMessage<PermissionCodeItem> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_staff_permission, 0);

/**
 * @generated from message api_proto.v1.ListPermissionCodesRequest
 */
export type ListPermissionCodesRequest = Message<"api_proto.v1.ListPermissionCodesRequest"> & {
};

/**
 * Describes the message api_proto.v1.ListPermissionCodesRequest.
 * Use `create(ListPermissionCodesRequestSchema)` to create a new message.
 */
export const ListPermissionCodesRequestSchema: GenMessage<ListPermissionCodesRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_staff_permission, 1);

/**
 * @generated from message api_proto.v1.ListPermissionCodesResponse
 */
export type ListPermissionCodesResponse = Message<"api_proto.v1.ListPermissionCodesResponse"> & {
  /**
   * @generated from field: repeated api_proto.v1.PermissionCodeItem permission_codes = 1;
   */
  permissionCodes: PermissionCodeItem[];
};

/**
 * Describes the message api_proto.v1.ListPermissionCodesResponse.
 * Use `create(ListPermissionCodesResponseSchema)` to create a new message.
 */
export const ListPermissionCodesResponseSchema: GenMessage<ListPermissionCodesResponse> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_staff_permission, 2);

/**
 * スタッフ 1 人分の権限付与状況
 *
 * @generated from message api_proto.v1.StaffPermissions
 */
export type StaffPermissions = Message<"api_proto.v1.StaffPermissions"> & {
  /**
   * @generated from field: int64 company_staff_id = 1;
   */
  companyStaffId: bigint;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * 停止（アーカイブ）中か。在籍の状態は有効と停止の2つだけで、停止は可逆（decisions.md決定90(a)）。
   * サポートアカウントのログインのON/OFF（is_support / support_access_active）は在籍とは別の軸（決定125）
   *
   * @generated from field: bool archived = 3;
   */
  archived: boolean;

  /**
   * @generated from field: repeated string permission_codes = 4;
   */
  permissionCodes: string[];

  /**
   * 所属するプラン種別。crm＝業務管理、ai_app＝営業支援。空＝どちらにも所属しない。
   * 所属はアクセスレベルではなく「どの契約を評価対象にするか」の絞り込み（決定89(a)）。
   * 業務管理プランのアカウント上限に算入するのは、業務管理（crm）に所属する有効スタッフだけ。
   *
   * @generated from field: repeated string plan_types = 5;
   */
  planTypes: string[];

  /**
   * 停止した日時（RFC3339）。空＝有効。解除すると空に戻る
   *
   * @generated from field: string archived_at = 6;
   */
  archivedAt: string;

  /**
   * ハウスケープのサポートアカウントか（決定125）。座席メーターの分子に入らない
   *
   * @generated from field: bool is_support = 7;
   */
  isSupport: boolean;

  /**
   * LINE自然文案件操作の準備状態（連携 / 友だち / 本人の権限 / 企業の権限データ / ready）。判定はサーバ。
   * CSが「LINEに来ない」の問い合わせで、どの条件が欠けているかを見るための表示材料（openspec/changes/line-readiness）
   *
   * @generated from field: api_proto.v1.LineReadiness line_readiness = 8;
   */
  lineReadiness?: LineReadiness;

  /**
   * LINE案件操作の最終利用日時（RFC3339。pending_line_operationsの最新のcreated）。空＝一度も使っていない
   *
   * @generated from field: string line_last_used_at = 9;
   */
  lineLastUsedAt: string;
};

/**
 * Describes the message api_proto.v1.StaffPermissions.
 * Use `create(StaffPermissionsSchema)` to create a new message.
 */
export const StaffPermissionsSchema: GenMessage<StaffPermissions> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_staff_permission, 3);

/**
 * @generated from message api_proto.v1.ListCompanyStaffPermissionsRequest
 */
export type ListCompanyStaffPermissionsRequest = Message<"api_proto.v1.ListCompanyStaffPermissionsRequest"> & {
  /**
   * @generated from field: int64 company_id = 1;
   */
  companyId: bigint;

  /**
   * 停止（アーカイブ）済みスタッフも含めるか。省略時は有効スタッフのみ返す（既定false）
   *
   * @generated from field: bool include_archived = 2;
   */
  includeArchived: boolean;
};

/**
 * Describes the message api_proto.v1.ListCompanyStaffPermissionsRequest.
 * Use `create(ListCompanyStaffPermissionsRequestSchema)` to create a new message.
 */
export const ListCompanyStaffPermissionsRequestSchema: GenMessage<ListCompanyStaffPermissionsRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_staff_permission, 4);

/**
 * 業務管理プランのアカウント上限に対する消費状況（座席メーター）
 *
 * @generated from message api_proto.v1.StaffCapacity
 */
export type StaffCapacity = Message<"api_proto.v1.StaffCapacity"> & {
  /**
   * 業務管理（crm）に所属する有効スタッフ数。停止中のスタッフは所属を保持したまま算入から外れる（決定90(p)）
   *
   * @generated from field: int64 assigned_active_count = 1;
   */
  assignedActiveCount: bigint;

  /**
   * アカウント上限。上書きがあれば上書き値、無ければプラン標準値（max_active_staffs）。
   * 業務管理契約が無ければ0とし、has_crm_contractがfalseなら「上限の概念なし」を表す
   *
   * @generated from field: int64 limit = 2;
   */
  limit: bigint;

  /**
   * 上限がAdminの上書き値（company_contracts.max_active_staffs_override）由来か
   *
   * @generated from field: bool has_override = 3;
   */
  hasOverride: boolean;

  /**
   * 業務管理（crm）のactive契約があるか。falseのときlimitは意味を持たない
   *
   * @generated from field: bool has_crm_contract = 4;
   */
  hasCrmContract: boolean;
};

/**
 * Describes the message api_proto.v1.StaffCapacity.
 * Use `create(StaffCapacitySchema)` to create a new message.
 */
export const StaffCapacitySchema: GenMessage<StaffCapacity> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_staff_permission, 5);

/**
 * @generated from message api_proto.v1.ListCompanyStaffPermissionsResponse
 */
export type ListCompanyStaffPermissionsResponse = Message<"api_proto.v1.ListCompanyStaffPermissionsResponse"> & {
  /**
   * @generated from field: repeated api_proto.v1.StaffPermissions staffs = 1;
   */
  staffs: StaffPermissions[];

  /**
   * 契約×プラン権限（+企業オーバーライド）による企業レベルの実効状態。スタッフ権限は含まない。
   * フロントはスタッフ付与コードのバッジに、この値で「閲覧のみ」「未契約」を添える。
   * access_levelがnoneの権限コードは要素を含めない（＝未契約。GetStaffMeのcompany_featuresと同じ表現）。
   *
   * @generated from field: repeated api_proto.v1.CompanyFeatureAccess company_features = 2;
   */
  companyFeatures: CompanyFeatureAccess[];

  /**
   * 業務管理プランの座席メーター（分子＝所属する有効スタッフ数、分母＝上限）
   *
   * @generated from field: api_proto.v1.StaffCapacity staff_capacity = 3;
   */
  staffCapacity?: StaffCapacity;
};

/**
 * Describes the message api_proto.v1.ListCompanyStaffPermissionsResponse.
 * Use `create(ListCompanyStaffPermissionsResponseSchema)` to create a new message.
 */
export const ListCompanyStaffPermissionsResponseSchema: GenMessage<ListCompanyStaffPermissionsResponse> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_staff_permission, 6);

/**
 * 指定スタッフの権限コードと所属プラン種別を全置換する（replace semantics。差分適用ではない）
 *
 * @generated from message api_proto.v1.UpdateCompanyStaffPermissionsRequest
 */
export type UpdateCompanyStaffPermissionsRequest = Message<"api_proto.v1.UpdateCompanyStaffPermissionsRequest"> & {
  /**
   * @generated from field: int64 company_id = 1;
   */
  companyId: bigint;

  /**
   * @generated from field: int64 company_staff_id = 2;
   */
  companyStaffId: bigint;

  /**
   * @generated from field: repeated string permission_codes = 3;
   */
  permissionCodes: string[];

  /**
   * 所属するプラン種別（crm / ai_app）の全置換。空＝所属なし。
   * 権限コードと所属を1トランザクションで置換するため同じリクエストに載せる。
   * 業務管理（crm）の所属を新たに付ける操作は、アカウント上限に達していると拒否される
   * （権限コードの付与そのものは算入に効かないので拒否しない。決定89(d)）。
   *
   * @generated from field: repeated string plan_types = 4;
   */
  planTypes: string[];
};

/**
 * Describes the message api_proto.v1.UpdateCompanyStaffPermissionsRequest.
 * Use `create(UpdateCompanyStaffPermissionsRequestSchema)` to create a new message.
 */
export const UpdateCompanyStaffPermissionsRequestSchema: GenMessage<UpdateCompanyStaffPermissionsRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_staff_permission, 7);

